import { createAxiosHttp } from "./createHttpRequest";

type IResult<T> = {
  code: number;
  message?: string;
  data: T
}

export type CreateMessageParams = {
  sender: string;
  subjectCode: string;
  content: string;
  url: string;
}

export type MessageListParams = {
  id: number;
  pageSize: number;
  sender: string;
  subjectCode: string;
  refresh: boolean;
}

export type MessageListItem = {
  id: number;
  content: string;
  createTime: string;
  direction: number;
  receiver: string;
  sender: string;
  url: string;
}
export type MessageListResult = {
  total: number;
  rows: MessageListItem[]
}

/**
 * 留言列表
 * @param params 
 * @returns 
 */
export const messageList = (params: MessageListParams)=> {
  return createAxiosHttp<IResult<MessageListResult>>({
    method: 'POST',
    url: 'knowledge/message/getList',
    data: params
  })
}

/**
 * 给患者留言
 * @param params 
 * @returns 
 */
export const createMessage = <T>(params: CreateMessageParams, fromDoctor: boolean = true)=> {
  return createAxiosHttp<IResult<CreateMessageParams>>({
    method: 'POST',
    url: `knowledge/message/${fromDoctor ? 'doctor/' : ''}create`,
    data: params
  })
}

type MessageSessionParams = {
  page: number;
  pageSize?: number;
  sender: string;
}
export const messageSession = <T>(params: MessageSessionParams)=> {
  return createAxiosHttp<IResult<T>>({
    method: 'POST',
    url: 'knowledge/message/getReceiverList',
    data: params
  })
}

type MessageUnreadCountParams = {
  subjectCode: string;
}
export type MessageUnreadCountResult = {
  [key: string]: number;
}
export const messageUnreadCount = (params: MessageUnreadCountParams)=> {
  return createAxiosHttp<IResult<MessageUnreadCountResult>>({
    method: 'POST',
    url: 'knowledge/message/getMessageLists',
    params
  })
}

// 聊天常用语
export type MessageFillResult = {
  id: number;
  content: string;
}
export const messageFill = ()=> {
  return createAxiosHttp<IResult<MessageFillResult[]>>({
    url: 'knowledge/message/template',
  })
}